import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import { AlertTriangle, ArrowRight } from 'lucide-react';

const fmt = (v) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(v);

export default function OverduePage() {
  const navigate = useNavigate();
  const [overdue, setOverdue] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiService.getOverduePayments()
      .then(setOverdue)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-3 sm:p-6">
      <div className="mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-1">Overdue Accounts</h1>
        <p className="text-slate-600 text-sm">Members with outstanding payments</p>
      </div>

      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="bg-gradient-to-r from-red-500 to-rose-600 text-white px-4 sm:px-6 py-4">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5" />
            <span className="font-semibold">
              {loading ? 'Loading…' : `${overdue.length} Account${overdue.length !== 1 ? 's' : ''} Overdue`}
            </span>
          </div>
        </div>

        {loading ? (
          <div className="text-slate-400 text-center py-16 text-sm">Loading…</div>
        ) : overdue.length === 0 ? (
          <div className="text-center py-16">
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-3">
              <AlertTriangle className="w-6 h-6 text-green-500" />
            </div>
            <p className="text-slate-500 font-medium">All accounts up to date!</p>
          </div>
        ) : (
          <div className="divide-y divide-slate-100">
            {overdue.map((item, i) => (
              <div key={i} className="flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors">
                <div>
                  <p className="font-semibold text-slate-800 text-sm">{item.member_name || item.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{item.membership_ref || item.reference}</p>
                </div>
                <div className="flex items-center gap-4">
                  <span className="font-bold text-red-600">{fmt(item.amount_due || item.outstanding || 0)}</span>
                  <button onClick={() => navigate(`/members/${item.member_id || item.id}`)}
                    className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm font-medium">
                    View <ArrowRight className="w-3 h-3" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
